import styled from "styled-components";
export const SelectContainer = styled.div`
  width: 100%;
  label {
    font-size: 14px;
    margin-bottom: 6px;
  }
  .select-area {
    width: 100%;
    position: relative;
    overflow: hidden;
    border-radius: 5px;
    border: solid 1px ${({ theme }) => theme.colors.inputBorder};
    border-color: ${({ error, theme }) =>
      error ? "red" : theme.colors.inputBorder};
    select {
      background-color: ${({ theme }) => theme.colors.background};
      color:${({ theme }) => theme.colors.font};
      padding: 10px 8px 6px 8px;
      border: none;
      font-size: ${({ theme }) => theme.sizes.font1};
      width: 110%;
      direction: ${({ ltr }) => (ltr ? "ltr" : "rtl")};
      line-height: 28px;
      height: 43px;
    }
    svg {
      font-size: 20px;
      position: absolute;
      left: 4px;
      top: 12px;
    }
    .error {
      position: absolute;
      right: 0;
      color: red;
      font-size: 8px;
      bottom: 0;
      padding: 0 4px;
      background: #fff;
      margin: 1px;
      border-radius: 4px;
      line-height: 9px;
    }
    ${({ required }) =>
      required
        ? `
    &:before {
      background: red;
      width: 5px;
      height: 5px;
      content: "";
      position: absolute;
      top: 3px;
      border-radius: 3px;
      right: 3px;
    }`
        : ""})};
  }

  @media only screen and (max-width: 760px) {
    .select-area {
      select {
        height: 39px;
      }
    }
  }
`;
